import actions from './actions';

const initState = {
    promotionInfo: {},
    promotions   : {
        data: []
    },
    loading : false,
    promotionDeleted : false
};

export default function fetchPromotionsReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_PROMOTIONS_REQUESTED:
            return {
                ...state,
                promotions   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_PROMOTIONS_SUCCEEDED:
            return {
                ...state,
                promotions    : action.promotions,
                loading     : false
            };
        case actions.FETCH_PROMOTIONS_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.FETCH_PROMOTION_REQUESTED:
            return {
                ...state,
                promotionInfo: {},
                loading : true
            };
        case actions.FETCH_PROMOTION_SUCCEEDED:
            return {
                ...state,
                promotionInfo: action.promotion,
                loading     : false
            };
        case actions.FETCH_PROMOTION_FAILED:
            return {
                ...state,
                loading : false
            };
        case actions.DELETE_PROMOTION_REQUESTED:
            return {
                ...state,
                promotionDeleted : false,
                loading : true
            };
        case actions.DELETE_PROMOTION_SUCCEEDED:
            return {
                ...state,
                promotionDeleted: true,
                loading     : false
            };
        case actions.DELETE_PROMOTION_FAILED:
            return {
                ...state,
                loading : false
            };
        default:
            return state;
    }
}
